import ManualAdditionSaman from "@/pages/DigitalAccount/Saman/Create/ManualAdditionSaman";
import { Card } from "@payping/web-components";
import { FormInstance } from "@payping/web-components/components/Form/types";
import React from "react";
import { SamanRowType } from "@/pages/DigitalAccount/Saman/Create/SecondStep";

interface Props {
  form: FormInstance<SamanRowType>;
}

const ManualRequestSaman: React.FC<Props> = ({ form }) => {
  return (
    <Card.Ant>
      <ManualAdditionSaman form={form} />
    </Card.Ant>
  );
};

export default ManualRequestSaman;
